import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const originalReplace = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalReplace.call(this, location).catch((err) => err)
}
export const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/login'),
  },
]
export const asyncRoutes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: '首页',
    },
    redirect: 'main',
    component: () => import('@/views/home'),
    children: [
      {
        path: 'main',
        name: 'Main',
        meta: {
          title: '首页',
          keepAlive: true,
          login: true,
        },
        component: () => import('@/views/main'),
      },
      {
        path: 'dispatch',
        name: 'Dispatch',
        meta: {
          title: '调度',
          keepAlive: true,
          login: true,
        },
        component: () => import('@/views/dispatch'),
      },
      {
        path: 'monitor',
        name: 'Monitor',
        meta: {
          title: '监控',
          keepAlive: true,
          login: true,
          hidenMap: true,
        },
        component: () => import('@/views/monitor'),
      },
      {
        path: 'praise',
        name: 'Praise',
        meta: {
          title: '口碑',
          keepAlive: true,
          login: true,
          hidenMap: true,
        },
        component: () => import('@/views/praise'),
      },
      {
        path: 'wifi',
        name: 'Wifi',
        meta: {
          title: 'Wi-Fi',
          keepAlive: true,
          login: true,
        },
        component: () => import('@/views/wifi'),
      },
      {
        path: 'demo',
        name: 'Demo',
        meta: {
          title: '动效demo',
          keepAlive: true,
          login: true,
        },
        component: () => import('@/views/demo'),
      },
      {
        path: 'ticketing',
        name: 'Ticketing',
        meta: {
          title: '票务',
          keepAlive: true,
          hidenMap: true,
          login: true,
        },
        component: () => import('@/views/ticketing'),
      },
      {
        path: 'parking',
        name: 'Parking',
        meta: {
          title: '停车场',
          keepAlive: true,
          hidenMap: true,
          login: true,
        },
        component: () => import('@/views/parking'),
      },
      {
        path: 'broadcast',
        name: 'Broadcast',
        meta: {
          title: '事件',
          keepAlive: true,
          login: true,
        },
        component: () => import('@/views/broadcast'),
      },
      {
        path: 'incident',
        name: 'Incident',
        meta: {
          title: '广播',
          keepAlive: true,
          login: true,
        },
        component: () => import('@/views/incident'),
      },
      {
        path: 'ridership',
        name: 'Ridership',
        meta: {
          title: '客流',
          keepAlive: true,
          login: true,
        },
        component: () => import('@/views/ridership'),
      },
    ],
  },
]
// const router = new VueRouter({
//   routes,
// })

const createRouter = () =>
  new VueRouter({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  })

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
export default router
